import { Component, inject, OnInit } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';

import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { confirmPasswordValidator } from '@shared/validators/password-match.validator';
import { ActivatedRoute } from '@angular/router';
import { UsersStore } from '@data-access/user/stores/users.store';
import { MatProgressBar } from '@angular/material/progress-bar';


@Component({
  selector: 'app-set-new-password',
  standalone: true,
  imports: [
    CommonModule,

    ReactiveFormsModule,

    MatIcon,
    MatButton,
    MatProgressBar
  ],
  templateUrl: './set-new-password.html',
  styleUrl: './set-new-password.scss'
})
export class SetNewPassword implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(UsersStore);

  mode: 'form' | 'message' = 'form';

  message = 'Somfew fwefih wefwe fewewf wefew';
  token = '';

  isLoading = false;

  ngOnInit() {
    const params = this.route.snapshot.fragment?.split('&');

    if (params?.length) {
      const token = params.reduce((token: string, item: string) => {
        const [key, value] = item.split('=');
        if (key !== 'access_token') {
          return token;
        }

        return value;
      }, '');

      if (token) {
        this.token = token;
      }
    }
  }

  isPasswordShown = false;
  form = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).*$/)]),
    passwordConfirm: new FormControl(''),
  }, { validators: confirmPasswordValidator });

  async send() {
    this.isLoading = true;

    const res = await this.store.setPassword(this.form.value.password!, this.token);

    this.isLoading = false;

    if (res) {
      this.form.reset();
      this.mode = 'message';
      this.message = res.message;
    }
  }

}
